// dashboard-vendas/frontend/src/features/products/services/catalogAPI.ts
import api from '../../../services/apiConfig';

/** Item de produto no catálogo cloud */
export interface CatalogProduct {
    ID: number;
    REFERENCIA: string;
    CA: string;
    DESCRICAO: string;
    ATIVO: string;
    GRUPO: string;
    FAMILIA: string;
    LINHA: string;
    LINHA2?: string;
    GRUPO2?: string;
    CABEDAL: string;
    SOLADO: string;
    BIQUEIRA: string;
    preco_r3: number;
    preco_r10: number;
}

/** Detalhes de um produto do catálogo */
export interface CatalogProductDetails {
    REFERENCIA: string;
    CA: string;
    DESCRICAO: string;
    GRUPO2: string;
    FAMILIA: string;
    LINHA: string;
    LINHA2: string;
    img: string | null;
}

/** Resposta da listagem paginada do catálogo */
interface CatalogResponse {
    products: CatalogProduct[];
    totalItems: number;
}

/** Parâmetros de busca do catálogo */
export interface CatalogParams {
    page?: number;
    limit?: number;
    search?: string;
}

/** Busca paginada de produtos do catálogo */
export const fetchCatalogProducts = async (params: CatalogParams): Promise<CatalogResponse> => {
    const response = await api.get<CatalogResponse>('/products/catalog', { params });
    return response.data;
};

/** Detalhes de um produto específico */
export const fetchCatalogProductDetails = async (productRef: string): Promise<CatalogProductDetails> => {
    const response = await api.get<CatalogProductDetails>(
        `/products/aws-details/${encodeURIComponent(productRef)}`
    );
    return response.data;
};
